const resource = '/admin/v1/papers';

export default $axios => ({
  index(payload) {
    return $axios.get(`${resource}`);
  },
});
